
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment choisir les mots-clés en référencement Web ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Comment une stratégie de mots-clés bien pensée peut optimiser votre référencement Google, attirer plus de visiteurs sur votre site et renforcer votre visibilité.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment choisir les mots-clés en référencement Web ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique comment booster votre référencement Google grâce à une stratégie de mots-clés bien ficelée !",
        },
      ],
    };
  },
};
